export default "__VITE_ASSET__DNEgzRy9__"